<script lang="ts" setup>
import RangeInput from '@/components/RangeInput.vue';
import { PriceType } from '@/views/search/types.ts';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';
import { faDollarCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { t } = useI18n();

const filters = useSearchFiltersStore();

const label = computed(() => (filters.priceType == PriceType.ForRent ? t('views.search.results.per-month') : ''));
</script>

<template>
  <div>
    <div class="mb-2 flex w-full items-center justify-start">
      <FontAwesomeIcon :icon="faDollarCircle" class="mr-2 h-4 text-gray-500" />
      {{ t('views.search.price') }} {{ label }}
    </div>
    <RangeInput
      v-model:max="filters.priceMax"
      v-model:min="filters.priceMin"
      :dollar-symbol="true"
      :range-distance="filters.priceRange.distance"
      :range-max="filters.priceRange.max"
      :range-min="filters.priceRange.min"
      :range-step="filters.priceRange.step"
      :unlimited-label="true"
    />
  </div>
</template>

<style lang="css" scoped></style>
